import axios from "axios";
import { getJwt } from "./authService";
import { getApiErrorToast, getToast } from "./appAlerts";
//import test from "./test";

//console.log(getJwt());
axios.defaults.headers.common["Authorization"] = "Bearer " + getJwt();
axios.defaults.headers.common["LoginType"] = localStorage.getItem("loginType");
axios.defaults.headers.common["Portal"] = "workbench";
//axios.defaults.baseURL = "https://localhost:44334/api/";
axios.defaults.baseURL = process?.env?.REACT_APP_API_BASEURL + "/api/";
const pendingGetRequests = new Map();
const cachedGetRequests = new Map();
const cancelTokens = new Map();
const DEFAULT_CACHE_DURATION = 60000;

const isAuthFlowRequest = (url) => {
  const normalizedUrl = String(url || "").toLowerCase();
  return (
    normalizedUrl.includes("auth/start") ||
    normalizedUrl.includes("auth/password")
  );
};

const getRequestKey = (url, config = {}) =>
  JSON.stringify({
    baseURL: config.baseURL || axios.defaults.baseURL,
    url: String(url || "").toLowerCase(),
    params: config.params || null
  });

axios.interceptors.request.use((config) => {
  config.headers = {
    ...config.headers,
    Authorization: "Bearer " + getJwt(),
    LoginType: localStorage.getItem("loginType"),
    Portal: "workbench"
  };

  return config;
});

axios.interceptors.response.use(null, (error) => {
  if (axios.isCancel(error)) return Promise.reject(error);

  const expectedError =
    error.response &&
    error.response.status >= 400 &&
    error.response.status < 500;

  if (!expectedError) {
    console.log("Logging the error", error);
    getApiErrorToast(error);
  } else {
    console.log(error.response);
    if (error.response.status === 401 && !isAuthFlowRequest(error.config?.url)) {
      localStorage.removeItem("token");
      localStorage.removeItem("currentUser");
      const message = error.response.data?.message === "Unauthorized"
        ? "Your access to the portal is deactivated, hence your session is being terminated"
        : error.response.data?.message;
      getToast(message || "Your session has expired. Please sign in again.", "error", { timer: 5000 });
      window.setTimeout(() => {
        window.location = "/login";
      }, 700);
    } else {
      getApiErrorToast(error);
    }
  }

  return Promise.reject(error);
});

function get(url, config = {}) {
  const {
    cache,
    cacheDuration = DEFAULT_CACHE_DURATION,
    dedupe = true,
    cancelPrevious = false,
    cancelKey,
    cacheKey,
    ...axiosConfig
  } = config;
  const requestKey = cacheKey || getRequestKey(url, axiosConfig);
  const cached = cache ? cachedGetRequests.get(requestKey) : null;

  if (cached && Date.now() - cached.timestamp < cacheDuration) {
    return Promise.resolve({ data: cached.data });
  }

  if (dedupe && pendingGetRequests.has(requestKey)) {
    return pendingGetRequests.get(requestKey);
  }

  if (cancelPrevious) {
    const cancel = cancelTokens.get(cancelKey || requestKey);
    if (cancel) cancel("Cancelled because a newer request was started.");
  }

  const source = axios.CancelToken.source();
  if (cancelPrevious) cancelTokens.set(cancelKey || requestKey, source.cancel);

  const request = axios
    .get(url, { ...axiosConfig, cancelToken: source.token })
    .then((response) => {
      if (cache) cachedGetRequests.set(requestKey, { data: response.data, timestamp: Date.now() });
      return response;
    })
    .finally(() => {
      pendingGetRequests.delete(requestKey);
      if (cancelPrevious) cancelTokens.delete(cancelKey || requestKey);
    });

  if (dedupe) pendingGetRequests.set(requestKey, request);
  return request;
}

function setJwt(jwt) {
  //console.log(jwt);
  axios.defaults.headers.common["Authorization"] = jwt;
}

export default {
  get,
  post: axios.post,
  put: axios.put,
  delete: axios.delete,
  patch: axios.patch,
  setJwt,
  baseURL: axios.defaults.baseURL,
};
